module.exports = __webpack_public_path__ + "officialStatic/img/news4.c92a235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/news4.png
// module id = Obj1
// module chunks = 0